.container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
}

.icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
